"use client";

import { motion } from "framer-motion";
import Image from "next/image";
import PartnerSlider from "./PartnerSlider";
import PartnerList from "./PartnerList";

interface ClientProps {
  data: any;
}

function PartnerSection({ data }: ClientProps) {
  const isBlue = data?.field_background_color === "blue";
  const isWhite = data?.field_background_color === "white";
  const isGray = data?.field_background_color === "gray";
  const isDarkDray = data?.field_background_color === "dark_gray";

  const bgClass = isBlue
    ? "bg-[#003350]"
    : isWhite
      ? "bg-white"
      : isGray
        ? "bg-[#f9f9f9]"
        : isDarkDray
          ? "bg-mapGray"
          : "bg-[#eeeff8]";

  return (
    <div
      className={`relative overflow-hidden ${bgClass} py-[120px] betweenMobileTab:py-16 mobileMax:py-10`}
    >
      <div className="relative overflow-x-hidden">
        <div className={`relative z-[2]`}>
          <div className="mini-container relative z-[2]">
            <motion.h3
              initial={{ opacity: 0, y: 35 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              className={`font-poppins text-transparent bg-clip-text ${
                isBlue
                  ? "bg-[#fff]"
                  : "bg-[linear-gradient(to_top,#8EBCE5,#11375C)]"
              } font-semibold desktop:text-[48px] leading-normal text-center text-[48px] mobileMax:text-[28px] mobileMax:px-0 mb-2`}
            >
              {data?.field_title || "Our Partners"}
            </motion.h3>

            <div
              className="text-[20px] list-disc text-center font-poppins mb-[40px] mobileMax:mb-6 mobileMax:text-xsmall mobileMax:leading-normal text-[#003350]"
              dangerouslySetInnerHTML={{
                __html: data?.field_description?.processed || "",
              }}
            />
          </div>

          {data?.field_partners_type === "rows" ? (
            <PartnerList data={data?.field_add_partner || []} />
          ) : (
            <PartnerSlider
              isHomePage
              sliderData={
                (data?.field_add_partner
                  ? data?.field_add_partner
                  : data?.sort((a: any, b: any) =>
                      a.title.localeCompare(b.title),
                    )) || []
              }
            />
          )}
        </div>
      </div>
    </div>
  );
}

export default PartnerSection;
